<app-spinner-page></app-spinner-page>
<div class="boton-index" style=" margin-top: 40%;" *ngIf="isLoadingFormulario">
  <app-spinner></app-spinner>
</div> 
<div class="page-container">

    <main class="contenido-principal">
        <div>
            <mat-toolbar class="nav-principal">
                <div>
                    <img class="nav-principal-logo-plataforma" src="../../../../assets/img/icon-modula.png" alt="Modula">               
                </div>
                <div style="padding-top: 10px;" class="nav-sidebar-logo-text">Modula - Form</div>     
            </mat-toolbar>
        </div>    
           
        <div *ngIf="visibleEncuesta">
            <!-- inicio -->
            <div class="contenedor-index" [ngStyle]="{    
                    'background-image': formulario.encabezado.path_fondo ? 'url(' + formulario.encabezado.path_fondo.path_image + ')' : 'none',
                    'background-color': formulario.encabezado.path_fondo ? 'transparent' : 'white'}" 
                    *ngIf="visible1" [@myInsertRemoveTrigger] >
                <div *ngIf="formulario.encabezado.codigo_encuesta" >
                    <div class="title-general" >                    
                        <img *ngIf="formulario.encabezado.path_logo" [src]="formulario.encabezado.path_logo.path_image" class="imagen2" alt="">                   
                      <div class="titulo-index">
                        Queremos conocer tu opinión.
                      </div>
                      <div class="boton-index" fxLayoutGap="5px" >
                        <button class="boton-index-color" mat-flat-button (click)="irEncuesta()" >Comenzar</button>                    
                      </div>
                    </div>
                  </div>
            </div>
            <!-- encuesta -->
            <div *ngIf="visible2" [@myInsertRemoveTrigger]>
                <div fxLayout="row" fxLayoutAlign="center center" style="margin-top: 50px;">
                    <img *ngIf="formulario.encabezado.path_logo" [src]="formulario.encabezado.path_logo.path_image" class="imagen" alt="">
                </div>
                <mat-divider></mat-divider>                       
                <mat-stepper #stepper orientation="vertical" linear [formGroup]="form" >
                  <ng-container *ngFor="let prgta of formulario.tipo_pregunta; let i = index" >

                    <!-- LISTA SELECCIONABLE -->
                    <ng-container *ngIf="prgta.tipo_pregunta == ListaTipoPregunta.TipoPregunta[0].codigo">
                      <mat-step [stepControl]="getFormGroupAt(i)" editable="false">
                        <form [formGroup]="getFormGroupAt(i)">
                          <ng-template matStepLabel>
                            <div style="margin-top: 20px;">
                              <h3>{{ prgta.pregunta }}</h3>
                            </div>
                          </ng-template>
                          <div fxLayout="row" fxLayoutAlign="space-around center">
                            <mat-form-field style="width: 30%;">
                              <mat-label>Opciones</mat-label>
                              <mat-select formControlName="opcion" required>
                                <mat-option *ngFor="let opt of prgta.lista_opcion" [value]="opt">{{ opt }}</mat-option>
                              </mat-select>
                              <mat-error *ngIf="getFormGroupAt(i).get('opcion')?.hasError('required')">
                                {{ Msjs_Validations.MSJ_VAL_CAMPO_VACIO }}
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div style="margin-top: 20px;">
                            <button mat-raised-button matStepperNext [disabled]="getFormGroupAt(i).invalid" class="btn-siguiente">
                              Siguiente
                            </button>
                          </div>
                        </form>
                      </mat-step>
                    </ng-container>

                    <!-- BINARIA -->
                    <ng-container *ngIf="prgta.tipo_pregunta == ListaTipoPregunta.TipoPregunta[1].codigo">
                      <mat-step [stepControl]="getFormGroupAt(i)" editable="false">
                        <form [formGroup]="getFormGroupAt(i)">
                          <ng-template matStepLabel>
                            <div style="margin-top: 20px;">
                              <h3>{{ prgta.pregunta }}</h3>
                            </div>
                          </ng-template>
                          <div fxLayout="row" fxLayoutAlign="space-evenly center" style="margin-top: 10px;">
                            <button mat-raised-button class="btn-omitir" type="button"
                              (click)="getFormGroupAt(i).get('respuesta_binaria')?.setValue(0); stepper.next()">
                              No
                            </button>
                            <button mat-raised-button class="btn-siguiente" type="button"
                              (click)="getFormGroupAt(i).get('respuesta_binaria')?.setValue(1); stepper.next()">
                              Sí
                            </button>
                          </div>
                        </form>
                      </mat-step>
                    </ng-container>
                    
                    <!-- SATISFACCION -->
                    <ng-container *ngIf="prgta.tipo_pregunta == ListaTipoPregunta.TipoPregunta[2].codigo">
                      <mat-step [stepControl]="getFormGroupAt(i)" editable="false">
                        <form [formGroup]="getFormGroupAt(i)">
                          <ng-template matStepLabel>
                            <div style="margin-top: 20px;">
                              <h3>{{ prgta.pregunta }}</h3>
                            </div>
                          </ng-template>
                          <section style="margin-top: 20px;" fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="10px" fxLayoutGap.xs="3px">
                            <button mat-fab fxShow fxHide.xs class="btn-sin-consumo" aria-label="no consumi" type="button"
                            (click)="getFormGroupAt(i).get('satisfaccion')?.setValue(0); stepper.next()">
                            <mat-icon class="large-icon">{{ Icons.CHEVRON_RIGHT }}</mat-icon>
                            </button>
                            <button fxShow.xs fxHide mat-mini-fab class="btn-sin-consumo" aria-label="no consumi" type="button"
                            (click)="getFormGroupAt(i).get('satisfaccion')?.setValue(0); stepper.next()">
                            <mat-icon class="xs-icon">{{ Icons.CHEVRON_RIGHT }}</mat-icon>
                            </button>

                            <button mat-fab fxShow fxHide.xs class="btn-muy-insatisfecho" aria-label="muy insatisfecho" type="button"
                              (click)="getFormGroupAt(i).get('satisfaccion')?.setValue(1); stepper.next()">
                              <mat-icon class="large-icon">{{ Icons.SENTIMENT_VERY_DISSATISFIED }}</mat-icon>
                            </button>
                            <button fxShow.xs fxHide mat-mini-fab class="btn-muy-insatisfecho" aria-label="muy insatisfecho" type="button"
                            (click)="getFormGroupAt(i).get('satisfaccion')?.setValue(1); stepper.next()">
                            <mat-icon class="xs-icon">{{ Icons.SENTIMENT_VERY_DISSATISFIED }}</mat-icon>
                            </button>

                            <button mat-fab fxShow fxHide.xs class="btn-insatisfecho" aria-label="insatisfecho" type="button"
                              (click)="getFormGroupAt(i).get('satisfaccion')?.setValue(2); stepper.next()">
                              <mat-icon class="large-icon">{{ Icons.SENTIMENT_DISSATISFIED }}</mat-icon>
                            </button>
                            <button fxShow.xs fxHide mat-mini-fab class="btn-insatisfecho" aria-label="insatisfecho" type="button"
                              (click)="getFormGroupAt(i).get('satisfaccion')?.setValue(2); stepper.next()">
                              <mat-icon class="xs-icon">{{ Icons.SENTIMENT_DISSATISFIED }}</mat-icon>
                            </button>

                            <button mat-fab fxShow fxHide.xs class="btn-neutro" aria-label="neutro" type="button"
                              (click)="getFormGroupAt(i).get('satisfaccion')?.setValue(3); stepper.next()">
                              <mat-icon class="large-icon">{{ Icons.SENTIMENT_NEUTRAL }}</mat-icon>
                            </button>
                            <button fxShow.xs fxHide mat-mini-fab class="btn-neutro" aria-label="neutro" type="button"
                              (click)="getFormGroupAt(i).get('satisfaccion')?.setValue(3); stepper.next()">
                              <mat-icon class="xs-icon">{{ Icons.SENTIMENT_NEUTRAL }}</mat-icon>
                            </button>

                            <button mat-fab fxShow fxHide.xs class="btn-satisfecho" aria-label="satisfecho" type="button"
                              (click)="getFormGroupAt(i).get('satisfaccion')?.setValue(4); stepper.next()">
                              <mat-icon class="large-icon">{{ Icons.SENTIMENT_SATISFIED }}</mat-icon>
                            </button>
                            <button fxShow.xs fxHide mat-mini-fab class="btn-satisfecho" aria-label="satisfecho" type="button"
                              (click)="getFormGroupAt(i).get('satisfaccion')?.setValue(4); stepper.next()">
                              <mat-icon class="xs-icon">{{ Icons.SENTIMENT_SATISFIED }}</mat-icon>
                            </button>

                            <button mat-fab fxShow fxHide.xs class="btn-muy-satisfecho" aria-label="muy satisfecho" type="button"
                              (click)="getFormGroupAt(i).get('satisfaccion')?.setValue(5); stepper.next()">
                              <mat-icon class="large-icon">{{ Icons.SENTIMENT_VERY_SATISFIED }}</mat-icon>
                            </button>
                            <button fxShow.xs fxHide mat-mini-fab class="btn-muy-satisfecho" aria-label="muy satisfecho" type="button"
                              (click)="getFormGroupAt(i).get('satisfaccion')?.setValue(5); stepper.next()">
                              <mat-icon class="xs-icon">{{ Icons.SENTIMENT_VERY_SATISFIED }}</mat-icon>
                            </button>

                          </section>
                        </form>
                      </mat-step>
                    </ng-container>
                    

                    <!-- OPINION -->
                    <ng-container *ngIf="prgta.tipo_pregunta == ListaTipoPregunta.TipoPregunta[3].codigo">
                      <mat-step [stepControl]="getFormGroupAt(i)" editable="false">
                        <form [formGroup]="getFormGroupAt(i)">
                          <ng-template matStepLabel>
                            <div style="margin-top: 20px;">
                              <h3>{{ prgta.pregunta }}</h3>
                            </div>
                          </ng-template>
                          <section style="margin-top: 20px;" fxLayout="row" fxLayoutAlign="space-around center">
                            <mat-form-field class="example-full-width">
                              <textarea matInput formControlName="comentario" placeholder="{{ prgta.pregunta }}"
                                minlength="10" maxlength="100"></textarea>
                              <mat-error *ngIf="getFormGroupAt(i).get('comentario')?.hasError('required')">
                                {{ Msjs_Validations.MSJ_VAL_CAMPO_VACIO }}
                              </mat-error>
                              <mat-error *ngIf="getFormGroupAt(i).get('comentario')?.hasError('pattern')">
                                {{ Msjs_Validations.MSJ_VAL_SOLO_LETRAS_Y_NUMEROS }}
                              </mat-error>
                              <mat-error *ngIf="getFormGroupAt(i).get('comentario')?.hasError('minlength')">
                                {{ Msjs_Validations.MSJ_VAL_DB_LENGTH_X_SMALL_MIN_10 }}
                              </mat-error>
                              <mat-error *ngIf="getFormGroupAt(i).get('comentario')?.hasError('maxlength')">
                                {{ Msjs_Validations.MSJ_VAL_DB_LENGTH_MEDIUM_MAX_100 }}
                              </mat-error>
                            </mat-form-field>
                          </section>
                          <section style="margin-top: 20px;" fxLayout="row" fxLayoutAlign="space-around center">
                            <button mat-raised-button class="btn-omitir" type="button"(click)="omitirPaso(i, stepper)">Omitir</button>
                            <button mat-raised-button class="btn-siguiente" matStepperNext [disabled]="getFormGroupAt(i).invalid">Siguiente</button>
                          </section>
                        </form>
                      </mat-step>
                    </ng-container>
                    

                     <!-- REGISTRO -->
                     <ng-container *ngIf="prgta.tipo_pregunta == ListaTipoPregunta.TipoPregunta[4].codigo">
                      <mat-step [stepControl]="getFormGroupAt(i)" editable="false">
                        <form [formGroup]="getFormGroupAt(i)">
                          <ng-template matStepLabel>
                            <div class="subtitulo"><span><h3>{{ prgta.pregunta }}</h3></span></div>
                          </ng-template>
                    
                          <section fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
                            <div fxLayout="row" fxLayoutGap="30px" fxLayout.xs="column" fxLayoutGap.xs="20px">
                              <mat-form-field>
                                <mat-label>Nombres</mat-label>
                                <input matInput formControlName="nombres"  oninput="this.value = this.value.toUpperCase()">
                                <mat-error *ngIf="getFormGroupAt(i).get('nombres')?.hasError('required')">
                                  {{ Msjs_Validations.MSJ_VAL_CAMPO_VACIO }}
                                </mat-error>
                              </mat-form-field>
                    
                              <mat-form-field>
                                <mat-label>Apellido Paterno</mat-label>
                                <input matInput formControlName="apellido_paterno"  oninput="this.value = this.value.toUpperCase()">
                                <mat-error *ngIf="getFormGroupAt(i).get('apellido_paterno')?.hasError('required')">
                                  {{ Msjs_Validations.MSJ_VAL_CAMPO_VACIO }}
                                </mat-error>
                              </mat-form-field>
                            </div>
                    
                            <div fxLayout="row" fxLayoutGap="20px" fxLayout.xs="column">
                              <mat-form-field>
                                <mat-label>Apellido Materno</mat-label>
                                <input matInput formControlName="apellido_materno"  oninput="this.value = this.value.toUpperCase()">
                                <mat-error *ngIf="getFormGroupAt(i).get('apellido_materno')?.hasError('required')">
                                  {{ Msjs_Validations.MSJ_VAL_CAMPO_VACIO }}
                                </mat-error>
                              </mat-form-field>
                    
                              <mat-form-field>
                                <mat-label>Sexo</mat-label>
                                <mat-select formControlName="sexo">
                                  <mat-option value="m">Masculino</mat-option>
                                  <mat-option value="f">Femenino</mat-option>
                                </mat-select>
                                <mat-error *ngIf="getFormGroupAt(i).get('sexo')?.hasError('required')">
                                  {{ Msjs_Validations.MSJ_VAL_CAMPO_VACIO }}
                                </mat-error>
                              </mat-form-field>
                            </div>
                    
                            <div fxLayout="row" fxLayoutGap="20px" fxLayout.xs="column">
                              <mat-form-field>
                                <mat-label>Correo electrónico</mat-label>
                                <input matInput formControlName="correo_electronico">
                                <mat-error *ngIf="getFormGroupAt(i).get('correo_electronico')?.hasError('required')">
                                  {{ Msjs_Validations.MSJ_VAL_CAMPO_VACIO }}
                                </mat-error>
                              </mat-form-field>
                    
                              <mat-form-field>
                                <mat-label>Número de teléfono</mat-label>
                                <input matInput formControlName="numero_telefono">
                                <mat-error *ngIf="getFormGroupAt(i).get('numero_telefono')?.hasError('required')">
                                  {{ Msjs_Validations.MSJ_VAL_CAMPO_VACIO }}
                                </mat-error>
                              </mat-form-field>
                            </div>
                    
                            <mat-divider></mat-divider>
                            <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="space-around center" style="text-align: center;">
                              <h1>GRACIAS</h1>
                              <h4>Tu opinión es muy importante para nosotros.</h4>
                            </div>
                          </section>
                    
                          <section style="margin-top: 20px;" fxLayout="row" fxLayoutAlign="space-around center">
                            <button mat-raised-button class="btn-omitir" type="button" (click)="omitirPaso(i, stepper)">Omitir</button>
                            <button mat-raised-button class="btn-siguiente" matStepperNext [disabled]="getFormGroupAt(i).invalid">
                              Siguiente
                            </button>
                          </section>
                        </form>
                      </mat-step>
                    </ng-container>
                    
                  </ng-container>
                  <mat-step [completed]="true" editable="false">
                    <ng-template matStepLabel>
                      <h3>Finalizar</h3>
                    </ng-template>
                  
                    <div fxLayout="column" fxLayoutAlign="center center" style="text-align: center; margin-top: 20px;">
                      <h1>¡Gracias por completar la encuesta!</h1>
                      <p>Puedes hacer clic en "Terminar" para enviar tus respuestas.</p>
                  
                      <button mat-raised-button color="primary" (click)="finalizarEncuesta()">Terminar</button>
                    </div>
                  </mat-step>
                  
                 
                </mat-stepper>
            </div>
        </div>
        <div style="margin-top: 50px;" *ngIf="paginaErrorNoDisponible">
          <app-ruta404 codigoError1="4" codigoError2="0" codigoError3="0" mensaje="Oops! Recurso no disponible." ></app-ruta404>
        </div>
        <div style="margin-top: 50px;" *ngIf="paginaErrorVisible">
          <app-ruta404></app-ruta404>
        </div>
    </main>
    <div class="footer">
        <app-footer></app-footer>
    </div>    
</div>

